import { Options, Paging, Sorting } from "@api/models/HttpClientModels";
import _, { merge } from 'lodash';
import { action, makeObservable, observable } from "mobx";
import { Params, SetURLSearchParams } from "react-router-dom";
import BasePaginationStore from "./BasePaginationStore";
import RootStore from "./RootStore";
import RESTCollectionModelBase from "@api/models/RESTCollectionModelBase";

export default class BaseFilterStore<Model, FilterType> extends BasePaginationStore<Model> {
    rootStore: RootStore;

    constructor(rootStore: RootStore, actions: Action<Model, FilterType>, sorting: Sorting = {}, options: Options = {},) {
        super();

        this.rootStore = rootStore;

        this.actions = actions;
        this.sorting = sorting;
        this.options = options;
        // merge(this.actions, actions)
        // merge(this.sorting, sorting);
        // merge(this.options, options);

        makeObservable(this, {
            filter: observable,
            options: observable,
            onFilter: action
        })
    }

    actions: Action<Model, FilterType>;

    memoryFilter: FilterType;
    filter: FilterType;
    options: Options;

    sorting: Sorting = {
        orderBy: "dateCreated",
        ascending: false
    }

    isRefreshRequired = true;
    setIsRefreshRequired = (value: boolean) => {
        this.isRefreshRequired = value;
    }

    searchParams: URLSearchParams;
    setSearchParams: SetURLSearchParams;

    initializeFilterAndFind = (searchParams: URLSearchParams, setSearchParams: SetURLSearchParams, params: Readonly<Params<string>>) => {
        this.resetPagingFilter();
        this.initializeSearchParamsHook(searchParams, setSearchParams);
        this.actions.initializeDefaultFilter(searchParams, params);

        this.onFilter();
    }

    onFilter = async () => {
        if (this.isRefreshRequired || JSON.stringify(this.filter) !== JSON.stringify(this.memoryFilter)) {
            this.memoryFilter = _.cloneDeep(this.filter);

            var response = await this.actions.filterAction(this.filter, this.sorting, this.pagingFilter, this.options);

            if (response !== undefined) {
                this.setPagination(response);
            }

            this.isRefreshRequired = false;
        }
    }

    initializeSearchParamsHook = (searchParams: URLSearchParams, setSearchParams: SetURLSearchParams) => {
        this.searchParams = searchParams;
        this.setSearchParams = setSearchParams;
    }

    onPageChange = (pageNumber: number) => {
        this.onPageNumberChange(pageNumber);
        this.setIsRefreshRequired(true);
        this.onFilter();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export type Action<Model, FilterType> = {
    filterAction: (filter: FilterType, sorting: Sorting, paging: Paging, options: Options) => Promise<RESTCollectionModelBase<Model> | undefined>,
    initializeDefaultFilter: (searchParams: URLSearchParams, params: Readonly<Params<string>>) => void
}